import * as actionTypes from "./actionTypes";
import orderService from "services/orderService";
import voucherService from "services/voucherService";
import paymentService from "services/paymentService";
import campaignRateService from "services/campaignRateService";
import timeUtils from "utils/time";
import { CHECKOUT_OUTCOME, mapCheckoutError } from "utils/checkoutError";
import { orderPlacedMessage } from "utils/orderConfirmation";
import { resolvePaymentFailure } from "utils/paymentFailure";

const menuResetState = () => {
  return {
    type: actionTypes.MENU_RESET_STATE
  };
};

export const cartResetState = () => dispatch => {
  return dispatch({
    type: actionTypes.CART_RESET_STATE
  });
};

const checkoutResetState = () => {
  return {
    type: actionTypes.CHECKOUT_RESET_STATE
  };
};

const cartSetPayInfo = payInfo => {
  return {
    type: actionTypes.CART_SET_PAY_INFO,
    payload: payInfo
  };
};

export const cartSetRestaurantOpen = payInfo => {
  return {
    type: actionTypes.CART_UPDATED_RESTAURANT_STATUS,
    payload: payInfo
  };
};

const discountOperationIsPercentage = voucher =>
  voucher.discountOperation === "%";

const maxBasketCostIsPresent = voucher => !!voucher.maxBasketCost;

export const calculateSubsidy = (idRestaurant, subtotal, taxDelivery, tipValue) => {

  return dispatch => {
    voucherService
      .calculateSubsidy({ idRestaurant: idRestaurant, value: subtotal })
      .then(data => {
        dispatch(cartSetRestaurantOpen(data.isBusinessCorporate))
        
          const discounts = data.discounts;
          const voucherWithMaxBasketCost =
          data.discounts.find(
            voucher =>
              discountOperationIsPercentage(voucher) &&
              maxBasketCostIsPresent(voucher)
          ) || {};
          if (subtotal !== data.newValue) {
            const subsidy = subtotal.toFixed(2) - data.newValue;
            const total = data.newValue + taxDelivery;
            console.log("subtotal if: ", subtotal)
            dispatch(
              appliedCartValues(
                subtotal,
                subsidy.toFixed(2),
                total,
                voucherWithMaxBasketCost.maxBasketCost,
                discounts,
                tipValue
              )
            );
          } else {
            const total = subtotal + taxDelivery;
            console.log("subtotal else: ", subtotal)
            dispatch(
              appliedCartValues(
                subtotal,
                0,
                total,
                voucherWithMaxBasketCost.maxBasketCost,
                discounts,
                tipValue
              )
            );
          }
        
        
      })
      .catch(err => {
        console.log(err);
      });
  };
};

export const fetchingCards = () => {
  return dispatch => {
    paymentService
      .getCards()
      .then(data => {
        dispatch(successFetchingCarts(data));
      })
      .catch(err => {
        console.log(err);
      });
  };
};

export const fetchingCampaignRate = idBusiness => {
  return dispatch => {
    campaignRateService
      .getCampaignRate(idBusiness)
      .then(campaignRates => {
        if (
          !campaignRates.find(
            campaignRate =>
              campaignRate.chargeType === "T" && campaignRate.status === "E"
          )
        ) {
          campaignRates.push({
            chargeType: "T",
            statusReg: "A",
            status: "E",
            amount: 10,
            discountType: "P"
          });
        }
        dispatch(successFetchingCampaignRate(campaignRates));
      })
      .catch(err => {
        console.log(err);
      });
  };
};

export const placeOrder = (order, payInfo) => {
  return dispatch => {
    return orderService
      .placeOrder(order)
      .then(data => {
        let payInfoUpdated = {
          ...payInfo,
          idOrder: data.id,
          publicOrderNumber: data.publicOrderNumber
        };
        dispatch(cartSetPayInfo(payInfoUpdated));
        dispatch(successPlaceOrder(data));
        dispatch(openModalPlacedOrderOnCart());
        dispatch(consumeVoucher(payInfoUpdated));
      })
      .catch(err => {
        dispatch(triggerModalErrorPlacedOrder(err));
      });
  };
};

export const placeOrderAndPay = (order, payInfo) => {

  let amout = payInfo.tipValue + payInfo.amount;

  payInfo.amount = amout;
  return dispatch => {
    return orderService
      .placeOrder(order)
      .then(data => {
        let payInfoUpdated = {
          ...payInfo,
          idOrder: data.id,
          publicOrderNumber: data.publicOrderNumber
        };
        dispatch(successPlaceOrder(data));
        dispatch(cartSetPayInfo(payInfoUpdated));
        dispatch(paymentOrder(payInfoUpdated));
      })
      .catch(err => {
        dispatch(triggerModalErrorPlacedOrder(err));
      });
  };
};

export const placeOrderAndGoToAddNewCard = (order, payInfo, history) => {

  return dispatch => {
    orderService
      .placeOrder(order)
      .then(data => {
        const payInfoUpdated = {
          ...payInfo,
          idOrder: data.id,
          publicOrderNumber: data.publicOrderNumber
        };
        dispatch(successPlaceOrder(data));
        dispatch(cartSetPayInfo(payInfoUpdated));
        history.push("/Menu/checkout");
      })
      .catch(err => {
        dispatch(triggerModalErrorPlacedOrder(err));
      });
  };
};

const reconcilePaymentFailure = (payload, error) => dispatch => {
  return resolvePaymentFailure(payload, error).then(checkoutError => {
    dispatch({
      type: actionTypes.TRIGGER_MODAL_ERROR_PLACED_ORDER,
      checkoutError,
    });
  });
};

export const paymentOrder = payload => {
  return dispatch => {
    return paymentService
      .pay(payload)
      // Handle the payment rejection in the same step so an error raised while
      // showing the result cannot trigger a second reconciliation.
      .then(data => {
        if (data.success) {
          dispatch(openModalPlacedOrderOnCart());
          dispatch(consumeVoucher(payload));
        } else {
          return dispatch(reconcilePaymentFailure(payload, data));
        }
      }, err => {
        return dispatch(reconcilePaymentFailure(payload, err));
      });
  };
};

export const consumeVoucher = payload => {
  return dispatch => {
    let confirmVoucher = (payload.payType === 'A' && payload.discounts.length > 0)
    let voucher = {
      idOrder: payload.idOrder,
      totalOrder: payload.amount,
      confirmVoucher: confirmVoucher,
      vouchers: payload.discounts
    };
    return voucherService
      .consume(voucher)
      .catch(err => {
        dispatch(triggerModalErrorPlacedOrder(err, {
          outcome: CHECKOUT_OUTCOME.CONFIRMED,
          orderNumber: payload.publicOrderNumber,
          postOrderFailure: true,
        }));
      });
  };
};


export const toggleCart = (status = null) => {
  return {
    type: actionTypes.TOGGLE_CART,
    status: status
  };
};

export const addProductToCart = payload => {
  return {
    type: actionTypes.ADD_PRODUCT_TO_CART,
    payload: payload
  };
};

export const deleteProductFromCart = payload => {
  return {
    type: actionTypes.DELETE_PRODUCT_FROM_CART,
    payload: payload
  };
};

export const deleteAllProductsFromCart = () => {
  return {
    type: actionTypes.DELETE_ALL_PRODUCTS_FROM_CART
  };
};

export const appliedCartValues = (subtotal, subsidy, total, maxBasketCost, discounts, tipValue) => {
  return {
    type: actionTypes.CART_CALCULATED_VALUES,
    subtotal: subtotal,
    subsidy: subsidy,
    tipValue: tipValue,
    total: total,
    maxBasketCost: maxBasketCost,
    discounts: discounts
  };
};

export const successFetchingCarts = cards => {
  return {
    type: actionTypes.SUCCESS_FETCHING_CARDS,
    cards: cards
  };
};

export const successFetchingCampaignRate = data => {
  return {
    type: actionTypes.SUCCESS_FETCHING_CAMPAIGN_RATE,
    campaignRate: data
  };
};

export const triggerModalErrorPlacedOrder = (error, context) => {
  return {
    type: actionTypes.TRIGGER_MODAL_ERROR_PLACED_ORDER,
    checkoutError: mapCheckoutError(error, context)
  };
};

export const successPlaceOrder = data => {
  return {
    type: actionTypes.SUCCESS_PLACE_ORDER,
    payload: {
      idOrder: data.id,
      publicOrderNumber: data.publicOrderNumber,
      orderDeliveryDate: timeUtils.dateArrayToDate(data.orderDeliveryDate),
      isInvoice: false,
      descriptionSuccess: orderPlacedMessage(data.publicOrderNumber)
    }
  };
};

export const closeModalErrorPlacedOrder = () => dispatch => {
  dispatch({ type: actionTypes.CLOSE_MODAL_ERROR_PLACED_ORDER });
  dispatch(toggleIsButtonDisabled(false));
};

export const openModalPlacedOrderOnCart = () => {
  return {
    type: actionTypes.CART_TOGGLE_SHOW_MODAL_PLACE_ORDER,
    payload: true
  };
};

export const closeModalPlacedOrderOnCart = history => dispatch => {
  dispatch(menuResetState());
  dispatch(cartResetState());
  dispatch(checkoutResetState());
  dispatch(toggleIsButtonDisabled(false));
  history.push("/Menu");
};

export const toggleIsButtonDisabled = disabled => {
  return {
    type: actionTypes.CART_SET_PLACED_BUTTON_DISABLED,
    payload: disabled
  };
};

export const openModalReceiptOnCart = () => dispatch => {
  dispatch({
    type: actionTypes.CART_TOGGLE_SHOW_MODAL_PLACE_ORDER,
    payload: false
  });
  dispatch({
    type: actionTypes.CART_TOGGLE_SHOW_MODAL_RECEIPT,
    payload: true
  });
};

export const closeModalReceiptOnCart = () => dispatch => {
  dispatch(menuResetState());
  dispatch(cartResetState());
  dispatch(checkoutResetState());
  dispatch(toggleIsButtonDisabled(false));
};

//////////////////////////////// Invoice //////////////////////////////////////

export const handlePayInvoice = (payload, history) => {
  return dispatch => {
    return paymentService
      .pay(payload)
      .then(data => {
        if (data.success) {
          dispatch(payInvoiceSuccess(data.description));
          dispatch(toggleCart(false));
          dispatch(openModalPlacedOrderOnCart());
          history.push("/Menu");
        } else {
          dispatch(triggerModalErrorPlacedOrder(data, {
            paymentOutcomeUnknown: true,
          }));
        }
      })
      .catch(error => {
        dispatch(triggerModalErrorPlacedOrder(error, {
          paymentOutcomeUnknown: true,
        }));
      });
  };
};

const payInvoiceSuccess = descriptionSucess => dispatch => {
  dispatch({
    type: actionTypes.INVOICE_PAY_SUCCESS,
    descriptionSuccess: descriptionSucess
  });
};

//////////////////////////////// Card //////////////////////////////////////

export const deleteCard = cardId => {
  return dispatch => {
    paymentService.deleteCard(cardId).then(result => {
      dispatch(fetchingCards());
    });
  };
};

export const changeDeliveryTomorrow = payload => dispatch => {
  dispatch({
    type: actionTypes.CART_DELIVERY_TOMORROW,
    payload: payload
  });
};



// WEBPACK FOOTER //
// ./src/store/actions/Cart.js